import { createSuspenseQuery } from "@steto-care/steto-query";

import { ConfigRepository } from "@/io/repository/ConfigRepository";

export class ConfigQueries {
  constructor(private readonly configRepository: ConfigRepository = new ConfigRepository()) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  useSupportInfo = createSuspenseQuery(
    "config",
    ({}) => [],
    async () => this.configRepository.getSupportInfo(),
  );
}
